import React from 'react';
import { PageIndices } from '../../common/i-doc/i-doc.registry.ts';
import { QuizBuilderEditorContent } from '../expert/QuizBuilderEditorPage';
import { adminQuestionnairesConstructionService } from '../../services/questionnaires-construction/questionnaires-construction.service';

/**
 * Адмінська версія `/quiz-builder/:templateId` — повний доступ до абсолютно всіх
 * шаблонів, включно з системними (readOnly не діє). Той самий UI, інший сервіс.
 */
const AdminQuizBuilderEditorPage: React.FC = () => (
  <QuizBuilderEditorContent
    service={adminQuestionnairesConstructionService}
    iDoc={PageIndices.ADMIN_QUIZ_BUILDER_EDITOR}
    titlePrefix="Адмін: Конструктор опитувань"
    isAdminMode
  />
);

export default AdminQuizBuilderEditorPage;
